import { ChargerProducts } from '../common/enums/Products'
import { ChargePointImport } from '../common/redux/api/web-api'

const isDawn = (entity: { productId?: number } | number | string): boolean => {
    if (typeof entity === 'number') {
        return entity === ChargerProducts.Dawn
    } else if (typeof entity === 'string') {
        return entity.toLowerCase() === 'dawn'
    } else if (typeof entity === 'object' && entity.productId) {
        return entity.productId === ChargerProducts.Dawn
    }

    return false
}

export const isDawnImport = (chargePoint: ChargePointImport | undefined) =>
    chargePoint && chargePoint.productType === 'Dawn'

export default isDawn
